module.exports = __webpack_public_path__ + "img/apply-s-ico1.71f1f9b2.png";